export const ANY_LOWERCASE_SYMBOL_REGEX = /^(?=.*[a-z])/;
export const ANY_UPPERCASE_SYMBOL_REGEX = /^(?=.*[A-Z])/;
export const ANY_NUMERIC_SYMBOL_REGEX = /^(?=.*\d)/;
export const ANY_SPECIAL_SYMBOL_REGEX = /^(?=.*[!@#$%^&*.])/;
export const LENGTH_REGEX = (min = '0', max = '') => new RegExp(`^[\\s\\S]{${min},${max}}$`);
export const DISALLOWED_PASSWORD_SYMBOLS_REGEX = /[^A-Za-z\d!@#$%^&*.]/;
export const FORBIDDEN_TEXT_CHARS_REGEX = /[@=;"']/gi;
export const FORBIDDEN_EMAIL_CHARS_REGEX = /[=;"']/gi;
export const FORBIDDEN_ACTIVE_DIRECTORY_CHARS_REGEX = /[=;"'<>]/gi;
export const SETTINGS_SUBPAGE_URL_REGEX = /^\/settings\/.*$/;
export const TIME_SPAN_REGEX = /^(\d+):(\d{2})(:(\d{2}))?$/;
export const FULL_TIME_SPAN_REGEX = /^-?(?:(\d+)\.)?(\d+):(\d{1,2})(?::(\d{1,2}))?(?:\.(\d+))?$/;
export const ALL_DOTS_REGEX = /\./g;
